import api from "@/lib/axios";

const getErrorMessage = (error, fallback) =>
  error.response?.data?.message || error.message || fallback;

export const marketingHistoryService = {
  getCampaignHistory: async (params = {}) => {
    try {
      const response = await api.get("/marketing/history/campaigns", {
        params,
      });
      return response.data;
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to fetch marketing history"),
      );
    }
  },

  getBatchRecipients: async (batchId, params = {}) => {
    try {
      const response = await api.get(
        `/marketing/history/batches/${batchId}/recipients`,
        { params },
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        const fallback = await api.get(
          `/marketing/history/campaigns/${batchId}/recipients`,
          { params },
        );
        return fallback.data;
      }
      throw new Error(
        getErrorMessage(error, "Failed to fetch recipient details"),
      );
    }
  },
};
